import React from 'react';
import PropTypes from 'prop-types'; 

import {
  StylesProvider,
  ThemeProvider as DefaultThemeProvider,
} from '@material-ui/core/styles';

import { Theme } from '../../theme';

const ThemeProvider = ({ children }) => {
  return (
    <StylesProvider injectFirst>
      <DefaultThemeProvider theme={Theme}>{children}</DefaultThemeProvider>
    </StylesProvider>
  );
};

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ThemeProvider;
